import React, { StrictMode } from 'react';

import { ContextProvider as UsersContextProvider } from 'components/Users/Context';
import { ContextProvider } from './Context';
import Main from './Main';

export default function Index() {
  return (
    <StrictMode>
      <UsersContextProvider>
        <ContextProvider>
          <Main />
        </ContextProvider>
      </UsersContextProvider>
    </StrictMode>
  );
}
